import request from "./base";
const path = "/recovery";

export default {
  sendEmailRecoveryPassword: function (params) {
    return request().post(path + "/", params);
  }
};
